<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Cadastrar Suporte") }}</h1>

        <b-card class="shadow">
            <loading-animation
                :active.sync="loading.form"
                :is-full-page="false"
                :opacity="1"
                color="#5895FF"
            />
            <form @submit.prevent="addSuporte" ref="addSuporte">
                <div class="row">
                    <form-input
                        v-model="ticket.subject"
                        grid="12"
                        label="Assunto"
                        :required="true"
                    />

                    <div class="col-md-12">
                        <label
                            class="block text-sm font-medium leading-5 text-gray-700"
                            for="ticket_body"
                            ><b
                                >{{
                                    $t(
                                        "Descreva de forma objetiva sua solicitação"
                                    )
                                }}
                                *</b
                            ></label
                        >
                        <div class="mt-1 relative rounded-md">
                            <input-wysiwyg
                                id="ticket_body"
                                v-model="ticket.body"
                                :plugins="{ images: true, attachment: true }"
                                @selectUploadFile="selectUploadFile"
                                :required="true"
                            >
                            </input-wysiwyg>

                            <div
                                class="progress mt-3"
                                style="height: 15px"
                                v-if="uploadingFileProgress > 0"
                            >
                                <div
                                    class="progress-bar"
                                    role="progressbar"
                                    :style="`width: ${uploadingFileProgress}%`"
                                    :aria-valuenow="uploadingFileProgress"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ uploadingFileProgress }}%
                                </div>
                            </div>

                            <label class="mt-2"><b>Anexos</b></label>
                            <b-form-file
                                ref="inputFile"
                                @change="uploadFile"
                                placeholder="Selecione em seu computador o arquivo que deseja enviar..."
                                drop-placeholder="Selecione em seu computador o arquivo que deseja enviar..."
                            ></b-form-file>
                        </div>
                    </div>
                    <div
                        v-if="ticket.attachments.length > 0"
                        class="col-md-12 mt-3 px-0"
                    >
                        <div
                            class="col-md-12"
                            v-for="(attachment, index) in ticket.attachments"
                            :key="index"
                        >
                            <attachment
                                :details="attachment"
                                v-on:remove="removeAttachment(index)"
                                :key="index"
                            />
                        </div>
                    </div>
                </div>
                <div class="float-right mt-3">
                    <router-link
                        class="btn btn-default"
                        to="/dashboard/admin/suportes"
                    >
                        <i class="mdi mdi-arrow-left" />
                    </router-link>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Create") }}
                    </button>
                </div>
            </form>
            <input
                ref="fileInput"
                hidden
                type="file"
                @change="uploadFile($event)"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    name: "Add",
    mounted() {
        this.$bvModal.show("add-ticket");
        this.loading.form = false;
    },
    data() {
        return {
            loading: {
                form: false,
                file: false,
            },
            uploadingFileProgress: 0,
            ticket: {
                subject: null,
                department_id: null,
                body: "",
                attachments: [],
                user_remetente: {
                    id_remetente: null,
                    nome_remetente: null,
                    email_remetente: null,
                    funcao_remetente: null,
                    unidade_id_remetente: null,
                    unidade_remetente: null,
                    cidade_remetente: null,
                    estado_remetente: null,
                },
            },
            departmentList: [],
        };
    },
    methods: {
        submitFile(files) {
            this.ticket.attachments = files;
        },
        // Add role
        addSuporte() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            const user = this.$store.state.user;

            this.ticket.user_remetente.id_remetente = user.id;
            this.ticket.user_remetente.nome_remetente = user.name;
            this.ticket.user_remetente.email_remetente = user.email;
            this.ticket.user_remetente.funcao_remetente =
                user.role_details.name;
            this.ticket.user_remetente.unidade_id_remetente = user.unidade.id;
            this.ticket.user_remetente.unidade_remetente = user.unidade.nome;
            this.ticket.user_remetente.cidade_remetente =
                this.$store.state.settings.app_cidade;
            this.ticket.user_remetente.estado_remetente =
                this.$store.state.settings.app_estado;

            // Send request
            axios
                .post(
                    this.$store.state.settings.app_suporte_url + "api/tickets",
                    this.ticket,
                    {
                        headers: {
                            Authorization:
                                "Bearer " +
                                localStorage.getItem("token_suporte"),
                        },
                    }
                )
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: "Suporte cadastrado com sucesso!",
                    });

                    this.$router.push("/dashboard/admin/suportes");
                });
        },
        selectUploadFile() {
            if (!this.loading.file) {
                this.$refs.fileInput.click();
            } else {
                swal.fire(
                    "Error " + this.$i18n.t("Error").toString(),
                    this.$i18n.t("A file is being uploaded").toString(),
                    "warning"
                );
            }
        },
        uploadFile(e) {
            const self = this;
            const formData = new FormData();
            self.loading.file = true;
            formData.append("file", e.target.files[0]);
            axios
                .post(
                    this.$store.state.settings.app_suporte_url +
                        "api/tickets/attachments",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization:
                                "Bearer " +
                                localStorage.getItem("token_suporte"),
                        },
                        onUploadProgress: function (progressEvent) {
                            self.uploadingFileProgress = Math.round(
                                (progressEvent.loaded / progressEvent.total) *
                                    100
                            );
                        }.bind(this),
                    }
                )
                .then(function (response) {
                    self.loading.file = false;
                    self.uploadingFileProgress = 0;
                    self.$refs.fileInput.value = null;
                    self.$refs.inputFile.value = null;
                    self.ticket.attachments.push(response.data);
                })
                .catch(function () {
                    self.loading.file = false;
                    self.uploadingFileProgress = 0;
                    self.$refs.fileInput.value = null;
                    self.$refs.inputFile.value = null;
                });
        },
        removeAttachment(attachment) {
            this.ticket.attachments.splice(attachment, 1);
        },
    },
};
</script>

<style>
.relative {
    position: relative;
    z-index: 1;
}
</style>
